module.exports = __webpack_public_path__ + "static/img/optional.0efc797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/no/optional.png
// module id = 1418
// module chunks = 1